import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BackButton from '../components/BackButton';
import Icon from '../components/Icon';
import './styles/VocabScreenStyles.css';

const VocabScreen = () => {
  const location = useLocation();
  const { chapterNumber, selectedChapter } = location.state || {};
  const navigation = useNavigate();
  const { t } = useTranslation();
  const flashcards = selectedChapter.vocabulary;
  const numberOfCardsPerTab = 40;
  const numVocabSelectors = Math.ceil(flashcards.length / numberOfCardsPerTab);

  const handleChapterPress = (vocabIndex) => {
    const startIdx = (vocabIndex - 1) * numberOfCardsPerTab;
    const endIdx = vocabIndex * numberOfCardsPerTab;
    const subsetflashcards = flashcards.slice(startIdx, endIdx);
    navigation('/flash-card', { state: { vocabIndex, subsetflashcards, selectedChapter } });
  };

  const renderVocabSelectors = () => {
    const selectors = [];
    for (let i = 1; i <= numVocabSelectors; i++) {
      const startIdx = (i - 1) * numberOfCardsPerTab + 1;
      const endIdx = Math.min(i * numberOfCardsPerTab, flashcards.length);
      selectors.push(
        <button
          className="chapter-tile"
          key={i}
          onClick={() => handleChapterPress(i)}
        >
          <span className="chapter-icon"><Icon name="book" size={24} color="var(--color-vocab)" /></span>
          <p className="chapterText">{`${t('vocabulary')} ${i}`}</p>
          <p className="chapter-count">{t('words')} {startIdx}–{endIdx}</p>
        </button>
      );
    }
    return selectors;
  };

  return (
    <div className="container">
      <BackButton to="/book-screen" label={t('chooseBook')} />
      <h2 className="page-title">{selectedChapter.name}</h2>
      <div className="book-selector">{renderVocabSelectors()}</div>
    </div>
  );
};

export default VocabScreen;
